module.exports = "/assets/data/1771f7a159b0e2a19ba76f577fceee76-NE6.data.json";